<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase" style="cursor:pointer;" @click="openHome">
        <img src="./assets/img/schmucklicloud_label_white.png" alt="schmuckliCloud" height="55">
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        flat
        dark
        @click="openAccount"
        target="_blank"
      >
        <span class="mr-2">{{ sign_in_dashboard_button }}</span>
      </v-btn>
    </v-toolbar>

    <v-content>
      <v-container>
        <router-view/>
      </v-container>
    </v-content>

    <!-- Notification -->
    <v-snackbar
      v-model="notification"
    >
      {{ notification_text }}
      <v-btn
        flat
        @click="notification = ''"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { User } from "./logic/User";
import { Notifications, NotificationsReceiver } from "./notification";

export default {
  name: 'App',
  data(){
    return {
      sign_in_dashboard_button: "Sign in"
    }
  },
  async mounted(){
    if (await User.isSignedIn()) {
      this.sign_in_dashboard_button = "Dashboard";
    } else {
      this.sign_in_dashboard_button = "Sign In";
    }
  },
  computed: {
    /* Notification */
    notification: {
      get() { return NotificationsReceiver.notification !== "" },
      set() { Notifications.show(""); }
    },
    notification_text(){
      return NotificationsReceiver.notification;
    }
  },
  methods: {
    openAccount(){
      this.$router.push("/login");
    },
    openHome(){
      this.$router.push("/");
    }
  }
}
</script>

<style>
@import url("./assets/css/layout.css");
@import url("./assets/css/dashboard.css");
</style>
